/* eslint-disable */
// src/layouts/visitMachine/strategies/calculateFormula.js

const OPS = ["+", "-", "*", "/"];

export function calculateFormula(base, formula) {
  const type = String(formula?.Type ?? "").trim();
  const value = Number(formula?.Value ?? 0);

  // Sin fórmula o inválida => no transforma
  if (!OPS.includes(type)) return base;

  switch (type) {
    case "+": return base + value;
    case "-": return base - value;
    case "*": return base * value;
    case "/": return value !== 0 ? base / value : 0;
    default:  return base;
  }
}
